import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/rv-search")({
  component: () => <Outlet />,
});
